import React, { useEffect, useRef, useCallback, useState } from "react";
import { debounce } from "lodash";

// hooks
import { useRedux } from "../../../hooks/index";

// hooks
import { useProfile } from "../../../hooks";
import { createSelector } from "reselect";
// components
import AppSimpleBar from "../../../components/AppSimpleBar";
import Loader from "../../../components/Loader";
import Message from "./Message";
// import Day from "./Day";

// interface
import { MessagesTypes } from "../../../data/messages";
import ForwardModal from "../../../components/ForwardModal";

// actions
import {
  forwardMessage, deleteImage, deleteMessage2s, addMessage2s, updateReadMsg
  , getChatUserConversations2, getChatUserConversationsPrev, getChatUserConversationsNext, viewMsgMember
} from "../../../redux/actions";

import ViewMsgMemberModa from "components/ViewMsgMemberModal";
import ViewMsgMemberModal from "components/ViewMsgMemberModal";
import ViewFileModal from "components/ViewFileModal";
import { compose } from "redux";
import AudioCallModal2 from "components/ViewMessageReadStatusModal";
import ViewMessageReadStatusModal from "components/ViewMessageReadStatusModal";
import { Utils } from "helpers/utils";
import { Const } from "const";
interface ConversationProps {
  chatUserConversations: any;
  chatUserDetails: any;
  onDelete: (messageId: string | number) => any;
  onSetReplyData: (reply: null | MessagesTypes | undefined) => void;
  isChannel: boolean;
}
const Conversation = ({
  chatUserDetails,
  chatUserConversations,
  onDelete,
  onSetReplyData,
  isChannel,
}: ConversationProps) => {
  // global store
  const { dispatch, useAppSelector } = useRedux();

  const { userProfile } = useProfile();

  const errorData = createSelector(
    (state: any) => state.Chats,
    (state) => ({
      getUserConversationsLoading: state.getUserConversationsLoading,
      isMessageForwarded: state.isMessageForwarded,
      message2s: state.chatUserConversations.messages,
      viewMsgMemberModalOpen: state.viewMsgMemberModalOpen,
      conversationId: state.chatUserConversations.conversationId,
      minTime: state.chatUserConversations.minTime,
      maxTime: state.chatUserConversations.maxTime,
      fetchType: state.chatUserConversations.fetchType,
      searchMsgId: state.chatUserConversations.searchMsgId,
      skipIndex: state.chatUserConversations.skipIndex,
      is2sAddingMessage: state.is2sAddingMessage // consider as adding message programmatically, no handle scroll bar
    })
  );
  // Inside your component
  const {
    getUserConversationsLoading, isMessageForwarded, message2s, viewMsgMemberModalOpen
    , conversationId, minTime, maxTime, fetchType, searchMsgId, skipIndex
    , is2sAddingMessage
  } = useAppSelector(errorData);

  useEffect(() => {
    // console.log('getUserConversationsLoading change to ' + getUserConversationsLoading);
  }, [getUserConversationsLoading]);

  const messages =
    chatUserConversations.messages && chatUserConversations.messages.length
      ? chatUserConversations.messages
      : [];

  const firstUnreadIndex = (messages || []).findIndex((m: any) => !m.isRead);
  const ref = useRef<any>();
  const scrollElement = useCallback(() => {
    // console.log('firstVisibleIndexWhenFetchBack = ' + firstVisibleIndexWhenFetchBack);
    /* old code scroll to bottom
    if (ref && ref.current) {
      const listEle = document.getElementById("chat-conversation-list");
      let offsetHeight = 0;
      if (listEle) {
        offsetHeight = listEle.scrollHeight - window.innerHeight + 250;
      }
      if (offsetHeight) {
        ref.current
          .getScrollElement()
          .scrollTo({ top: offsetHeight, behavior: "smooth" });
      }
    }*/
    //  console.log('scrollElement');
    if (ref && ref.current) {
      //      console.log('scroll:', {fetchType, searchMsgId});
      if (fetchType == "initial" || fetchType == "initial_search") { // scroll to unread
        const simpleBarElement = ref.current.getScrollElement();
        // console.log('simpleBarElement:', simpleBarElement);
        const listEle = document.getElementById("chat-conversation-list");
        if (fetchType == "initial_search" && searchMsgId) {
          // Find the LI element with the matching m-id
          const targetLi = Array.from((listEle as any).children).find((li: any) => li.getAttribute("m-id") === searchMsgId) as any;
          if (targetLi) {
            // Scroll to the element and try to keep it in the middle of the container
            targetLi.scrollIntoView({
              behavior: "instant",
              block: "center" // Scroll so the element appears in the center
            });
            targetLi.classList.add("shake");
            setTimeout(() => {
              targetLi.classList.remove("shake");
            }, 3000);
          }

        } else {
          const scrollToIndex = firstUnreadIndex >= 0 ? firstUnreadIndex : ((listEle?.children?.length ?? 0) - 1);
          //console.log('conversation initial scroll ', { firstUnreadIndex, scrollToIndex });

          if (scrollToIndex >= 0) {
            const listItem = listEle?.children[scrollToIndex] as HTMLElement;
            const toBottom = scrollToIndex == ((listEle?.children?.length ?? 0) - 1);
            // console.log('scroll to:', listItem);
            // console.log('listItem:', listItem);
            //listItem?.scrollIntoView({ behavior: "smooth", block: "center" });
            if (toBottom) {
              simpleBarElement.scrollTop = simpleBarElement.scrollHeight;
              // console.log('scroll to bottom');
            } else {
              listItem?.scrollIntoView({ behavior: "instant", block: "center" });
            }
          }
        }
        // console.log('scrollIntoView');

        // get visible item to make it readed
        const containerRect = simpleBarElement.getBoundingClientRect(); // Get the container's visible area
        const listItems = listEle?.querySelectorAll('li'); // Get all <li> elements inside the container
        const visibleItems: any[] = [];
        (listItems || []).forEach((item) => {
          if (item.getAttribute("is-read") == "0") {
            const itemRect = item.getBoundingClientRect(); // Get each item's position and size
            // Check if the item is within the visible area of the container
            if (
              itemRect.top >= containerRect.top &&
              itemRect.bottom <= containerRect.bottom
            ) {
              visibleItems.push(item.getAttribute('m-id'));
            }
          }
        });
        if (visibleItems && visibleItems.length > 0) {
          //console.log('visible on initial:', visibleItems);
          debounceSendReadMessages(visibleItems);
        }
      } else if (fetchType == "prev") {
        //console.log('set visible when fetch prev');
        const listEle = document.getElementById("chat-conversation-list");
        const listItem = listEle?.children[skipIndex] as HTMLElement;
        listItem?.scrollIntoView({ behavior: "instant", block: "start" });
        // console.log('scrollIntoView2');

      } else if (fetchType == "New message") {
        const listEle = document.getElementById("chat-conversation-list");
        if (listEle) {
          const scrollToIndex = (listEle?.children?.length ?? 0) - 1;
          if (scrollToIndex) {
            const listItem = listEle?.children[scrollToIndex] as HTMLElement;
            //listItem?.scrollIntoView({ behavior: "instant", block: "center" });
            listItem?.scrollIntoView({ behavior: "instant", block: "end" });
            // setTimeout(() => {
            //   listEle.scrollTop = listEle.scrollHeight; // Scroll to the bottom
            //   console.log('scroll bottom');
            // }, 1500); // Delay for 500ms            
          }
          const simpleBarElement = ref.current.getScrollElement();
          // const simpleBar = listEle.closest(".simplebar-content-wrapper");
          if (simpleBarElement) {
            // console.log('scroll bottom app simple bar');
            simpleBarElement.scrollTop = simpleBarElement.scrollHeight; // Scroll the SimpleBar container to the bottom
            setTimeout(() => {
              simpleBarElement.scrollTop = simpleBarElement.scrollHeight;
              // console.log('scroll bottom');
            }, 500); // Delay for 500ms                 
          }
        }

      } else if (fetchType == 'I Add') {
        const listEle = document.getElementById("chat-conversation-list");
        if (listEle) {
          const scrollToIndex = (listEle?.children?.length ?? 0) - 1;
          if (scrollToIndex) {
            const listItem = listEle?.children[scrollToIndex] as HTMLElement;
            //listItem?.scrollIntoView({ behavior: "instant", block: "center" });
            listItem?.scrollIntoView({ behavior: "instant", block: "end" });
            const simpleBarElement = ref.current.getScrollElement();
            // const simpleBar = listEle.closest(".simplebar-content-wrapper");
            if (simpleBarElement) {
              // console.log('scroll bottom app simple bar');
              simpleBarElement.scrollTop = simpleBarElement.scrollHeight; // Scroll the SimpleBar container to the bottom
              setTimeout(() => {
                simpleBarElement.scrollTop = simpleBarElement.scrollHeight;
                // console.log('scroll bottom');
              }, 500); // Delay for 500ms                 
            }
          }
        }

      }

    }
  }, [ref, firstUnreadIndex, fetchType, searchMsgId, skipIndex]);
  const [firstVisibleIndexWhenFetchBack, setFirstVisibleIndexWhenFetchBack] = useState<any>(-1);

  useEffect(() => {
    if (ref && ref.current) {
      ref.current.recalculate();
      const backButton = document.getElementById("back-button") as HTMLButtonElement | null;
      if (backButton) {
        if (firstUnreadIndex > 0 && firstUnreadIndex < (messages ?? []).length - 4) { // have unread
          // console.log('useEffect show back button');
          backButton.classList.add("show");
          backButton.setAttribute('mode', 'buttom');
        } else {
          backButton.classList.remove("show");
        }
      }
    }

    const debounceFetchOther = debounce((direction) => {
      if (direction == 1) {
        // console.log('getChatUserConversationsNext:', { conversationId, maxTime });
        dispatch(getChatUserConversationsNext(conversationId, maxTime));

      } else if (direction == -1) {
        // console.log('getChatUserConversationsPrev:', {conversationId, minTime});
        dispatch(getChatUserConversationsPrev(conversationId, minTime));
      }

    }, 200); // Adjust the debounce time as necessary       

    const getFirstVisibleMessageIndex = () => {
      const ulElement = chatRef.current;
      if (!ulElement) return null;
      const messagesList = Array.from(ulElement.children); // Get all the <li> elements
      // Loop through the messages and find the first one that's visible
      for (let i = 0; i < messagesList.length; i++) {
        const messageElement = messagesList[i];
        const rect = messageElement.getBoundingClientRect();

        // Check if the message element is within the visible area of the container
        if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
          return i;//messageElement; // Return the first visible message
        }
      }
      return -1;
    }

    let prevTop: number = -1;

    const handleScroll = () => {
      // console.log('In Scroll getUserConversationsLoading = ' + getUserConversationsLoading);
      if (is2sAddingMessage) return;

      // console.log('chat message scrolling');
      const liVisible = getFirstVisibleMessageIndex();
      setFirstVisibleIndexWhenFetchBack(liVisible);
      // console.log('LI Visible = ', liVisible);


      // console.log("on scroll");
      // const simpleBarElement = ref.current.getScrollElement();
      const scrollTop = scrollableNode.scrollTop;
      const scrollHeight = scrollableNode.scrollHeight;
      const clientHeight = scrollableNode.clientHeight;

      const backButton = document.getElementById("back-button") as HTMLButtonElement | null;
      if (backButton) {
        const isNotAtBottom = scrollableNode.scrollHeight - scrollableNode.scrollTop > scrollableNode.clientHeight + 10;
        // console.log('isNotAtBottom=' + isNotAtBottom);
        if (isNotAtBottom) {
          // console.log('downbutton show');
          backButton.classList.add("show");
          backButton.setAttribute('mode', 'buttom');
        } else {
          // console.log('downbutton hide');
          backButton.classList.remove("show");
          backButton.setAttribute('mode', '');
        }
      }



      if (prevTop == -1) prevTop = scrollTop;
      if (scrollTop < prevTop && scrollTop < 10) {
        debounceFetchOther(-1);
        // console.log('scroll near top:', { scrollTop, prevTop });
      } else if (scrollTop > prevTop && (scrollHeight - scrollTop - clientHeight < 10)) {
        // console.log('scroll near bottom');
        debounceFetchOther(1);
      }
      prevTop = scrollTop;
    };

    const scrollableNode = ref.current?.getScrollElement();
    if (scrollableNode) {
      scrollableNode.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (scrollableNode) {
        scrollableNode.removeEventListener("scroll", handleScroll);
      }
    };
  }, [conversationId, minTime, maxTime, dispatch, ref, is2sAddingMessage]);

  // useEffect(() => {
  //   console.log('useEffect.is2sAddingMessage = ' + is2sAddingMessage);
  // }, [is2sAddingMessage]);

  useEffect(() => {
    // console.log('[chatUserConversations.messages, scrollElement]');
    if (chatUserConversations.messages) {
      scrollElement();
    }
  }, [chatUserConversations.messages, scrollElement]);

  /*
  forward message
  */
  const [forwardData, setForwardData] = useState<
    null | MessagesTypes | undefined
  >();
  const [isOpenForward, setIsOpenForward] = useState<boolean>(false);
  const onOpenForward = (message: MessagesTypes) => {
    setForwardData(message);
    setIsOpenForward(true);
  };
  const onCloseForward = () => {
    setIsOpenForward(false);
  };

  const onForwardMessage = (data: any) => {
    const params = {
      contacts: data.contacts,
      message: data.message,
      forwardedMessage: forwardData,
    };
    dispatch(forwardMessage(params));
  };
  useEffect(() => {
    if (isMessageForwarded) {
      setIsOpenForward(false);
    }
  }, [isMessageForwarded]);

  /*
  image delete
  */
  const onDeleteImage = (
    messageId: string | number,
    imageId: string | number
  ) => {
    dispatch(deleteImage(chatUserDetails.id, messageId, imageId));
  };

  // const fnTestAdd = () => {
  //   // console.log(message2s);
  //   const newMsg = {
  //     mId: 1,
  //     text: "Good morning !! 😊",
  //     time: new Date().toISOString(),
  //     meta: {
  //       receiver: '123',
  //       sender: "614ecab4ac946a9bdafa4e3b",
  //       sent: true,
  //       received: true,
  //       read: true,
  //     },
  //   }
  //   dispatch(addMessage2s(newMsg));
  //   //dispatch(deleteMessage2s('8807ea56-ab24-4553-b7b9-f6c19e9b8ae8'));
  //   // console.log(messages);
  // }


  /* code for detect read - start */
  const chatRef = useRef<HTMLUListElement | null>(null); // Correctly typing the ref
  const [windowActive, setWindowActive] = useState(true); // check if window active
  const [visibleMessages, setVisibleMessages] = useState(new Set());
  const visibleMessagesRef = useRef(new Set());

  useEffect(() => {
    const handleVisibilityChange = () => {
      // console.log('windows active = ' + (!document.hidden));
      setWindowActive(!document.hidden);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const debounceSendReadMessages = debounce((messageIds) => {
    if (!Utils.IsViewAs()) {
      // Send a batch request to the API
      // console.log('dispatch(updateReadMsg(messageIds)):', messageIds);
      // dispatch(updateReadMsg(messageIds));
      // setVisibleMessages(new Set()); // Clear the tracked messages

      // console.log('dispatch(updateReadMsg(messageIds)):', messageIds);
      // console.log('debounc update read:', [chatUserDetails.id, messageIds]);
      dispatch(updateReadMsg(chatUserDetails.id, messageIds));

      // Update `is-read` attribute to "1" for each element in `messageIds`
      messageIds.forEach((mid: any) => {
        const element = document.querySelector(`.chat-list[m-id="${mid}"]`);
        if (element) {
          element.setAttribute('is-read', '1');
          element.classList.remove('read-no-dark');
          element.classList.remove('read-no-light');
        }
      });
    }
    visibleMessagesRef.current.clear(); // Clear the tracked messages    
  }, 1000); // Adjust the debounce time as necessary  

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && windowActive) {
          const mid = entry.target.getAttribute('m-id');
          if (mid && !visibleMessagesRef.current.has(mid)) {
            // console.log('add ' + mid);
            visibleMessagesRef.current.add(mid);
          }
        }
      });

      if (visibleMessagesRef.current.size > 0) {
        debounceSendReadMessages(Array.from(visibleMessagesRef.current));
      }
    });

    if (chatRef.current) {
      const messageElements = chatRef.current.querySelectorAll<HTMLLIElement>('.chat-list[is-from-me="0"][is-read="0"]');
      // console.log('rebuild observer:' + messageElements.length + ' element');
      messageElements.forEach((el) => observer.observe(el));

      return () => {
        messageElements.forEach((el) => observer.unobserve(el));
      };
    }
  }, [windowActive, messages]);

  // useEffect(()=>{
  //   console.log('viewMsgMemberModalOpen:' + viewMsgMemberModalOpen);
  // },[viewMsgMemberModalOpen]);

  const [isOpenAudioModal, setIsOpenAudioModal] = useState<boolean>(false);
  const onOpenAudio = () => {
    //console.log('UserProfilesDetails.onOpenAudioClick');
    setIsOpenAudioModal(true);
  };
  const onCloseAudio = () => {
    setIsOpenAudioModal(false);
  };


  const [isViewMessageReadStatusModal, setIsViewMessageReadStatusModal] = useState<boolean>(false);
  const [mIdViewMessageReadStatusModal, setMIdViewMessageReadStatusModal] = useState<string>('');
  const onCloseViewMessageReadStatusModal = () => {
    setIsViewMessageReadStatusModal(false);
    setMIdViewMessageReadStatusModal("");
  }
  const onViewReadStatus = (mId: string) => {
    setMIdViewMessageReadStatusModal(mId);
    setIsViewMessageReadStatusModal(true);
    // console.log('view ' + mId);
  }

  const goToMsgId = (mId: any) => {
    try {
      const chatList = chatRef.current;
      const message = chatList?.querySelector(`li[m-id="${mId}"]`);

      if (message) {
        message.scrollIntoView({ behavior: "smooth", block: "center" });
        message.classList.add("shake");
        setTimeout(() => {
          message.classList.remove("shake");
        }, 3000);
      }
    } catch (e) {
      console.error(e);
      alert((e as any).message);
    }
  }

  const onClickDownButton = (e: any) => {
    try {
      const backButton = e.target;
      const goToMid = backButton.getAttribute('go-to-mid');
      const mode = backButton.getAttribute('mode');
      // console.log({ goToMid, mode });
      if (goToMid && goToMid != '') {
        // console.log('go to ' + goToMid + ' and show button');
        goToMsgId(goToMid);
        backButton.classList.remove("show")
        backButton.setAttribute('go-to-mid', '');
        // const msgPrev = chatList?.querySelector(`li[m-id="${fromId}"]`);
        // if (msgPrev){
        //   msgPrev.scrollIntoView({ behavior: "smooth", block: "center" });
        // }
      } else if (mode == "buttom") {
        dispatch(getChatUserConversations2(conversationId, null, null, null, null, true, "Click down button"));
        // console.log('go to bottom');
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onClickReplyMsg = (fromId: any, mId: any) => {
    try {
      const chatList = chatRef.current;
      const message = chatList?.querySelector(`li[m-id="${mId}"]`);
      const backButton = document.getElementById("back-button") as HTMLButtonElement | null;

      if (message) {
        goToMsgId(mId);
        // const previousScrollPosition = chatList?.scrollTop;
        // console.log('previousScrollPosition:', previousScrollPosition);
        // message.scrollIntoView({ behavior: "smooth", block: "center" });
        // console.log('previousScrollPosition:', chatList?.scrollTop);
        if (backButton) {
          backButton?.classList.add("show");
          // Add an event listener to the Back button
          backButton.setAttribute('go-to-mid', fromId);
          /* 20250402 change to use function
          backButton.onclick = () => {
            goToMsgId(fromId);
            // const msgPrev = chatList?.querySelector(`li[m-id="${fromId}"]`);
            // if (msgPrev){
            //   msgPrev.scrollIntoView({ behavior: "smooth", block: "center" });
            // }

            backButton.classList.remove("show"); // Hide the button after use
          };
          */
        }
        // message.classList.add("shake");
        // setTimeout(() => {
        //   message.classList.remove("shake");
        // }, 3000);
      } else {
        alert('ไม่พบข้อความบนหน้าจอ อาจเป็นข้อความเก่า');
      }
    } catch (e) {
      console.error(e);
      alert((e as any).message);
    }
  }

  return (
    <>
      {getUserConversationsLoading && <Loader />}
      <AppSimpleBar
        scrollRef={ref}
        className="chat-conversation p-3 p-md-4 positin-relative"
      >
        {/* {getUserConversationsLoading && <Loader />} */}
        {/* <div className="loading-overlay-full-parent">55555</div> */}
        <ul
          className="list-unstyled chat-conversation-list "
          id="chat-conversation-list"
          ref={chatRef}
        >
          {(messages || []).map((message: MessagesTypes, key: number) => {
            //const isFromMe = (message.meta ? (message.meta.sender + "" === userProfile.uid + "") : false);
            //const isFromMe = message.meta.sender + "" === userProfile.uid + "";
            if (message.type == "date-divider") {
              return (<li key={key}><div className={Utils.GetCssSuffixTheme("conver-date-divider")} >--- {message.text} ---</div></li>);
            } else if (message.senderId == Const.USER_ID_LOG) {
              return (
                <li key={key}>
                  <div style={{ width: "100%" }} className="text-center">
                    {/* {message.htmlContent ?
                      (<span className={Utils.GetCssSuffixTheme("conver-log")} dangerouslySetInnerHTML={{ __html: message.htmlContent }}></span>) :
                      (<span className={Utils.GetCssSuffixTheme("conver-log")}>{message.text}</span>)
                    } */}

                    <span className={Utils.GetCssSuffixTheme("conver-log")}>
                      {Utils.GetShortDateTimeToShowInChat(message.time, false)} :&nbsp;
                      {message.htmlContent ?
                        (<span dangerouslySetInnerHTML={{ __html: message.htmlContent }}></span>) :
                        (<span >{message.text}</span>)
                      }
                    </span>

                  </div>
                </li>
              );
            } else {
              const isFromMe = message.isFromMe;
              return (
                <Message
                  message={message}
                  key={key}
                  chatUserDetails={chatUserDetails}
                  onDelete={onDelete}
                  onSetReplyData={onSetReplyData}
                  isFromMe={isFromMe}
                  onOpenForward={onOpenForward}
                  isChannel={isChannel}
                  onDeleteImage={onDeleteImage}
                  onViewReadStatus={onViewReadStatus}
                  onClickReplyMsg={onClickReplyMsg}
                />
              );
            }
          })}
          {/*  <Day /> */}
        </ul>
        {/* <button onClick={onOpenAudio}>audio</button> */}
        {/* <button onClick={fnTestAdd}>test add</button> */}
        {/* <button id="back-button" className="btn btn-secondary back-button"> <i className='bx bxs-caret-down-circle'></i> </button> */}



        {isOpenForward && (
          <ForwardModal
            isOpen={isOpenForward}
            onClose={onCloseForward}
            forwardData={forwardData}
            chatUserDetails={chatUserDetails}
            onForward={onForwardMessage}
          />
        )}

        {isViewMessageReadStatusModal && (
          <ViewMessageReadStatusModal
            isOpen={isViewMessageReadStatusModal}
            onClose={onCloseViewMessageReadStatusModal}
            mId={mIdViewMessageReadStatusModal}
          />
        )}

        {/* <ViewMsgMemberModal isOpen={viewMsgMemberModalOpen} /> */}
        {/* <ViewFileModal></ViewFileModal> */}

        {/* <div className="alert alert-danger">{getUserConversationsLoading ? "loading" : "loaded"}</div> */}

      </AppSimpleBar>
      <i id="back-button" className='back-button bx bx-down-arrow-circle hande' onClick={(e) => onClickDownButton(e)} ></i>
    </>
  );
};

export default Conversation;
